import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';

export const useGetRetailOrders = (vanityOrders: boolean | undefined, imeOrders: boolean | undefined,
    closedOrders: boolean, dateFrom: Date | null) => {
    const { data, isLoading } = useQuery({
        queryKey: ['retail-orders-orders', vanityOrders, imeOrders, closedOrders, dateFrom],
        queryFn: async () => await apiClient.get(`retail-order/dealer-orders`,
            {
                params: {
                    vanityOrders: vanityOrders,
                    imeOrders: imeOrders,
                    closedOrders: closedOrders,
                    dateFrom: dateFrom ? dateFrom.toISOString().substring(0, 10) : ''
                }
            }) as []
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
